<template>
  <div id="app">
		<router-view/>
	</div>
</template>
<script>
	export default {
		name: 'App',
		data() {
			return {				
			}
		},
	}
</script>
<style lang="less">
	.flexBtw{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.mainArea{
		width: calc(100% - 300px);
		margin-left:140px;
		margin-right:140px;
	}
	
	html{
		scroll-behavior: smooth;
	}
	body *{
		
	    box-sizing: border-box;
	    flex-shrink: 0;
			color: #fff;
	}
	*{
	    margin: 0;
	    padding: 0;
	  }
	
	  img {
	    vertical-align: top;
	    border: 0;
	  }
	  li{list-style: none;}
	  a {
	    color: inherit;
	    text-decoration: none;
	  }
	  a[href] {
	    cursor: pointer;
	  }
	  a:hover {
	    text-decoration: none;
	    cursor: pointer;
	  }
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
	position: relative;
  
}
@media (max-width:1440px) {
		.mainArea{
			width: calc(100% - 100px);
			margin-left:40px;
			margin-right:40px;
		}
	}
	@media (max-width:800px) {
		.mainArea{
			width: calc(100% - 20px);
			margin-left:10px;
			margin-right:10px;
		}
	}
</style>
